module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.pageCls
  }, [_c('div', {
    staticClass: "g-main"
  }, [(_vm.showAppTopLink && !_vm.$route.query.isGovPreviewPage) ? _c('a', {
    staticClass: "app-top-link openApp",
    attrs: {
      "href": "javascript:;"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.showAppBotLink) ? _c('a', {
    staticClass: "app-bot-link openApp",
    attrs: {
      "href": "javascript:;",
      "id": "openApp"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.appBotLinkText) + "\n            ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ea55dd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-common.vue
// module id = 835
// module chunks = 2